/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterDefinitionEbsConfiguration } from './emrClusterDefinitionEbsConfiguration';


export interface MasterInstanceDefinition { 
    instanceCount?: number;
    instanceType: string;
    ebsConfiguration?: EmrClusterDefinitionEbsConfiguration;
    /**
     * The instance bid price, in USD. If not specified, uses on-demand
     */
    instanceSpotPrice?: number;
    /**
     * The maximum amount, in USD, to search for the best price. The best price search will only search for prices lower than this                   value. If a spot instance is selected by the search, this value will be the bid price                
     */
    instanceMaxSearchPrice?: number;
    /**
     * <p>The amount, in USD, you are willing to pay over the lowest spot price for an on-demand instance. Use this to                   dynamically balance the cost vs. stability of your instances.</p>                   <p>If not specified, the search will not attempt to find an on-demand instance when a spot is found. This is the same behavior as when                   this parameter is set to $0.</p>                
     */
    instanceOnDemandThreshold?: number;
}
